export {default as quadtree} from "./src/quadtree";



//////////////////
// WEBPACK FOOTER
// ./~/d3-quadtree/index.js
// module id = 544
// module chunks = 3